"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCurrency = exports.formatWithDecimals = exports.formatWithCommas = exports.formatDate = exports.formatSize = void 0;
const date_fns_1 = require("date-fns");
const DATE_FORMAT = 'MMM d, yyyy';
const DATETIME_FORMAT = `${DATE_FORMAT} h:mm a`;
function formatSize(bytes, decimals = 2) {
    if (bytes === 0)
        return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
exports.formatSize = formatSize;
function formatDate(value, dateOnly = false) {
    if (!value)
        return '';
    return date_fns_1.format(typeof value === 'string' ? new Date(value) : value, dateOnly ? DATE_FORMAT : DATETIME_FORMAT);
}
exports.formatDate = formatDate;
// NOTE: taken from https://stackoverflow.com/a/2901298/7013346
function formatWithCommas(value) {
    const parts = value.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
}
exports.formatWithCommas = formatWithCommas;
function formatWithDecimals(value, digits = 2) {
    let parsedValue = parseFloat(`${value}`);
    parsedValue = isFinite(parsedValue) ? parsedValue : 0;
    return parsedValue.toFixed(digits);
}
exports.formatWithDecimals = formatWithDecimals;
function formatCurrency(value, currency = '$') {
    return currency + formatWithCommas(formatWithDecimals(value));
}
exports.formatCurrency = formatCurrency;
//# sourceMappingURL=formatter.js.map